import {
  Directive,
  HostListener,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { Subject} from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { vshcDialogOpen } from '../../dialog.action';
import { BaseClass, isOnDestroy } from '../../../core';

@Directive({
  selector: '[vshcNgrxDialogOpen]',
  standalone: true
})
export class NgrxDialogOpenDirective extends BaseClass implements OnInit {

  #store = inject(Store<any>);

  @Input()
  vshcNgrxDialogOpen: string;

  @Input()
  vshcNgrxDialogOpenMeta: any;

  private _onOpen$ = new Subject<void>();

  constructor() {
    super();
  }

  @HostListener('click')
  onClick() {
    this._onOpen$.next();
  }

  override ngOnInit() {
    this._onOpen$
      .pipe(
        map(() => vshcDialogOpen({
          key: this.vshcNgrxDialogOpen,
          meta: this.vshcNgrxDialogOpenMeta
        })),
        takeUntil(this.lifecycle$.pipe(isOnDestroy()))
      )
      .subscribe(this.#store);
  }
}
